document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper('.swiper', {
        loop: true,
        spaceBetween: 16,
        pagination: {
            el: '.swiper-pagination',
        },
        breakpoints: {
            '768': {
                slidesPerView: 1,
            },
            '1024': {
                slidesPerView: 2,
            },
            '1280': {
                slidesPerView: 3,
            },
        },
    });
});
